import { createSelector } from '@ngrx/store';

import { onlineMenuPagesImagesState } from '../root';

export const getOnlineMenuPagesImages = createSelector(onlineMenuPagesImagesState, (onlineMenuPagesImages) => onlineMenuPagesImages);
